<div class="mx-auto text-center">
    <pagination-template #p="paginationApi" [id]="paginationConfig.id" (pageChange)="paginationConfig.currentPage =
    $event">
        <div class="pagination-previous pagination-number" [class.disabled]="p.isFirstPage()" (click)="p.setCurrent(p.pages[0].value)">
            <a> <fa-icon [icon]="faAngleDoubleLeft"></fa-icon> </a>
        </div>
        <div class="pagination-previous pagination-number" [class.disabled]="p.isFirstPage()" (click)="p.previous()">
            <a> <fa-icon [icon]="faAngleLeft"></fa-icon> </a>
        </div>
        <div class="pagination-number" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value" (click)="p.setCurrent(page.value)">
            <a *ngIf="p.getCurrent() !== page.value">
                <span>{{ page.label }}</span>
            </a>
            <div *ngIf="p.getCurrent() === page.value">
                <span>{{ page.label }}</span>
            </div>
        </div>
        <div class="pagination-next pagination-number" [class.disabled]="p.isLastPage()" (click)="p.next()">
            <a> <fa-icon [icon]="faAngleRight"></fa-icon> </a>
        </div>
        <div class="pagination-previous pagination-number" [class.disabled]="p.isLastPage()" (click)="p.setCurrent(p.pages[p.pages.length - 1].value)">
            <a> <fa-icon [icon]="faAngleDoubleRight"></fa-icon> </a>
        </div>
    </pagination-template>
</div>
